export default __webpack_public_path__ + "static/media/star.3417df16.png";